// Do not alter this file, instead it should be generated by using `yarn svg`
// This will override this file and update the exported enum for use in the SvgIcon component

export enum BOISvg {
    arrowLeft = 'arrowLeft',
    arrowRight = 'arrowRight',
    basket = 'basket',
    bike = 'bike',
    bikefast = 'bikefast',
    bookOpen = 'bookOpen',
    book = 'book',
    btnSocialClub = 'btnSocialClub',
    btnSocialFacebook = 'btnSocialFacebook',
    btnSocialInstagram = 'btnSocialInstagram',
    btnSocialNewsletter = 'btnSocialNewsletter',
    btnSocialPinterest = 'btnSocialPinterest',
    checkmark = 'checkmark',
    chevronDown = 'chevronDown',
    chevronLeft = 'chevronLeft',
    chevronRight = 'chevronRight',
    circle = 'circle',
    click = 'click',
    clockfast2 = 'clockfast2',
    contract = 'contract',
    creditCard = 'creditCard',
    cross = 'cross',
    de = 'de',
    disc = 'disc',
    dk = 'dk',
    dots = 'dots',
    download = 'download',
    equalizer = 'equalizer',
    es = 'es',
    fail = 'fail',
    fi = 'fi',
    fr = 'fr',
    frameWithTagline = 'frameWithTagline',
    frame = 'frame',
    gbEng = 'gbEng',
    gb = 'gb',
    gift = 'gift',
    headphones = 'headphones',
    heartSolid = 'heartSolid',
    heart = 'heart',
    history = 'history',
    house = 'house',
    info = 'info',
    it = 'it',
    list = 'list',
    lock = 'lock',
    loupe = 'loupe',
    mail = 'mail',
    mobilePay = 'mobilePay',
    money = 'money',
    nl = 'nl',
    no = 'no',
    package = 'package',
    pickup = 'pickup',
    pin1 = 'pin1',
    pin2 = 'pin2',
    pl = 'pl',
    playFill = 'playFill',
    play = 'play',
    questionMark = 'questionMark',
    se = 'se',
    shoppingBag = 'shoppingBag',
    smartPhone = 'smartPhone',
    sort = 'sort',
    starFull = 'starFull',
    starHalf = 'starHalf',
    star = 'star',
    storeFront = 'storeFront',
    store = 'store',
    tag = 'tag',
    trash = 'trash',
    truck2 = 'truck2',
    truck = 'truck',
    userAlt = 'userAlt',
    wishCloud = 'wishCloud',
    youtube = 'youtube',
}